module.exports = "/_next/static/images/LG-8714553ec3b0ce5ca2089e52dc8dae34.svg";